import React from 'react';
import { formatDateTime } from './formatting';

import styles from './review_actions.module.css';

// Reviewed and read are separate states: an event can be read but not reviewed, and reviewing one
// implies it has been read. Both apply to the whole account, so the wording says so rather than
// leaving a reviewer to assume the change is only theirs.
export default function ReviewActions({ event, saving, error, onToggleReviewed, onMarkUnread }) {
  return (
    <footer className={styles.footer}>
      {error && <p className={styles.error}>{error}</p>}

      <label className={styles.checkbox}>
        <input
          checked={Boolean(event.reviewed)}
          disabled={saving}
          onChange={() => onToggleReviewed(!event.reviewed)}
          type='checkbox'
        />
        <span className={styles.checkbox_label}>Mark as reviewed</span>
      </label>

      {event.reviewed ? (
        <p className={styles.attribution}>
          Reviewed by {event.reviewed_by || 'a colleague on your account'} on {formatDateTime(event.reviewed_at)}
        </p>
      ) : (
        <p className={styles.attribution}>Not yet marked reviewed by anyone on your account.</p>
      )}

      <div className={styles.actions}>
        <button className={styles.unread} disabled={saving} onClick={onMarkUnread} type='button'>
          Mark as unread
        </button>
      </div>
    </footer>
  );
}
